// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"54":"68d7c325","197":"d6c48a24","672":"79c6a637"}[chunkId] + ".js";
};